import React from "react";

// Official Digimonk.AI brand wordmark (green "D" glyph + metallic silver
// "DIGIMONK" + green ".AI"). Transparent background so it works on both the
// light navbar and the dark footer.
export const Logo = ({ className = "", dark = false }) => {
  void dark;
  return (
    <img
      src="/digimonk-wordmark.webp"
      alt="Digimonk.AI"
      className={`h-7 w-auto select-none sm:h-8 ${className}`}
      draggable={false}
    />
  );
};

export default Logo;
